import store from '../store'
import api from './api'
import moment from 'moment'

function getLatestTcsVersion() {
  return 3
}

function buildValidations(field) {
  var validations = {
    required: false
  }
  if(field.required) validations.required = true
  if(field.type == 'DATE') validations.date_format = 'dd/MM/yyyy'
  if(field.type == 'INTEGER') validations.numeric = true
  if(field.key == 'employerEmail') validations.email = true
  if(field.key == 'email') validations.email = true
  if(field.key == 'enrolYear' || field.key == 'gradYear') validations.min_value = "1900"
  if(store.state.minYear) {
    if(field.key == 'gradYear') {
      validations.min_value = store.state.minYear
    }
  } 
  return validations
}

function buildVerification(verification) {
  return {
      id: verification ? verification.id : null,
      firstname: verification ? verification.fields['firstname'] : null,
      middlename: verification ? verification.fields['middlename'] : null,
      lastname: verification ? verification.fields['surname'] : null,
      dob: verification ? parseFieldValue('DATE', verification.fields['dob']) : null,
      organisation: verification ? (verification.company ? verification.company : verification.institute) : null,
      customerReference: verification ? verification.customerReference : null,
      approvedByName: verification ? verification.approvedByName : null,
      approvedByTitle: verification ? verification.approvedByTitle : null,
      outputDocs: (verification && verification.documents) ? verification.documents.filter(doc => {return doc.output}) : [],
      additionalFieldData: verification ? verification.additionalFieldData : null,
      partnerBrand: verification ? verification.partnerBrand : null,
      accreditation: verification ? verification.accreditation : null,
      institute: null
  }
}

function populateEmploymentVerification(verification) {
  return new Promise((resolve, reject) => {
    this.buildInstitute("QC_EMP_VER")
        .then(response => {
          verification.institute = response
          verification.type = 'employment'
          resolve(verification)
        })
        .catch(error => {
          console.log(error)
          reject("Failed to build employment verification")
        })
  })
}

function buildInstitute(instituteId, verification, applicationId) {
  return new Promise((resolve, reject) => {
    api.getInstitute(instituteId, applicationId)
      .then(response => {
        let initFields = []
        for (var key in response.data.fields) {
          // skip loop if the property is from prototype
          if (!response.data.fields.hasOwnProperty(key)) continue
          var field = response.data.fields[key]
          if (field.key === 'firstname' || field.key == 'surname' || field.key === 'middlename' ||field.key === 'dob') continue
          initFields.push({
            key: field.key,
            label: field.name,
            description: field.description,
            required: field.required,
            minYear: response.data.minYear,
            type: field.type,
            refData: field.refData,
            values: field.values,
            value: verification ? parseFieldValue(field.type, verification.fields[field.key]) : null
          })
        }

        let initDocuments = []
        if (response.data.documentRequirements) {
          response.data.documentRequirements.forEach(function(doc){
            doc.id = null
            doc.verificationId = verification ? verification.id : null
            doc.filename = null
            doc.required = true
            doc.data = null
            initDocuments.push(doc)
          })
        }
        if(verification && verification.documents) {
          verification.documents.forEach(function(doc) {
            let found = false
            initDocuments.forEach(function(initDoc) {
              if(doc.name === initDoc.name) {
                found = true
                initDoc.id = doc.id
                initDoc.filename = doc.filename
                initDoc.data = doc.data
              } 
            })
            if(!found) {
              doc.required = false
              initDocuments.push(doc)
            }
          })
        }

        resolve({
          id: response.data.id,
          name: response.data.name,
          names: response.data.names,
          region: response.data.region.name,
          regionId: response.data.region.id,
          minYear: response.data.minYear,
          product: response.data.product,
          surcharge: response.data.surcharge,
          total: response.data.totalPrice,
          accreditation: response.data.accreditation,
          fields: initFields,
          documents: initDocuments,
          notices: response.data.notices,
          allowsPending: response.data.allowsPending,
          readOnly: response.data.readOnly,
          maxAdditionalDocs: response.data.maxAdditionalDocs,
          customerReference: response.data.customerReference
        })
      })
      .catch(error => {
        console.log(error)
        reject("Failed to get Institute Details")
      })
  }) 
}

function buildVerificationSubmission(verification, applicationId) {
    let fieldsBuilder = {
      firstname: verification.firstname,
      middlename: verification.middlename,
      surname: verification.lastname,
      dob: formatDate(verification.dob),
    }
    verification.institute.fields.forEach(field => {
      if(field.value) {
        if(field.type === 'DATE') {
          fieldsBuilder[field.key] = formatDate(field.value)
        } else if(field.type === 'INTEGER') {
          fieldsBuilder[field.key] = parseInt(field.value)
        } else {
          fieldsBuilder[field.key] = field.value
        }
      }
    })
    let docsBuilder = []
    if(verification.institute.documents && verification.institute.documents.length > 0) {
      verification.institute.documents.forEach(document => {
        docsBuilder.push({
          id: document.id,
          name: document.name,
          data: document.data
        })
      })
    }
    var built = {
      instituteId: verification.institute.id,
      fields: fieldsBuilder,
      documents: docsBuilder,
      customerReference: verification.customerReference,
      applicationId: applicationId,
      type: getType(verification.type),
      accreditation: verification.accreditation ? {instituteId: verification.institute.id} : null
    }
    if(verification.supplierId) {
      built.supplierId = verification.supplierId
    }
    if(verification.subjects && verification.subjects.length > 0) {
      built.additionalFieldData = [{subjects: verification.subjects}]
    }

    return built
}

function getType(type) {
  switch(type) {
    case 'education': return 'UNI'
    case 'employment': return 'EMPLOYMENT'
    case 'proflic': return 'PROF_LIC'
    case 'profcert': return 'PROF_CERT'
    case 'highschl': return 'HIGH_SCHOOL'
    case 'id': return 'IDENTITY'
    default: return 'UNI'
  }
}

function buildApplicationDocuments(application) {
    let initDocuments = []
    if (application.documentRequirements) {
      application.documentRequirements.forEach(function(doc){
        doc.id = null
        doc.applicationId = application.id
        doc.filename = null
        doc.required = true
        doc.data = null
        initDocuments.push(doc)
      })
    }
    if(application.documents) {
      application.documents.forEach(function(doc) {
        let found = false
        initDocuments.forEach(function(initDoc) {
          if(doc.name === initDoc.name) {
            found = true
            initDoc.id = doc.id
            initDoc.filename = doc.filename
            initDoc.data = doc.data
          } 
        })
        if(!found) {
          doc.required = false
          initDocuments.push(doc)
        }
      })
    }
    application.documents = initDocuments
}

function parseFieldValue(type, value) {
  if(!value) {
    return null
  } else if(type === 'DATE') {
    return moment(value).format('DD/MM/YYYY')
  } else if(type === 'INTEGER') {
    return value.toString()
  } else {
    return value
  }
}

function formatDate(date) {
  return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
}

function isEdu(instituteOrId) {
  return !isEmp(instituteOrId) && !isId(instituteOrId) && !isHSC(instituteOrId)
}

function isEmp(instituteOrId) {
  if(!instituteOrId) {
    return false
  }
  if(isString(instituteOrId)) {
    if(instituteOrId.startsWith('QC_EMP_VER')) {
      return true
    }
  } else if(instituteOrId.id && instituteOrId.id.startsWith('QC_EMP_VER')) {
    return true
  }
  return false
}

function isId(instituteOrId) {
  if(!instituteOrId) {
    return false
  }
  if(isString(instituteOrId)) {
    if(instituteOrId.startsWith('QC_ID_VER')) {
      return true
    }
  } else if(instituteOrId.id && instituteOrId.id.startsWith('QC_ID_VER')) {
    return true
  }
  return false
}

function isHSC(instituteOrId) {
  if(!instituteOrId) {
    return false
  }
  if(isString(instituteOrId)) {
    if(instituteOrId.startsWith('QC_HS_VER')) {
      return true
    }
  } else if(instituteOrId.id && instituteOrId.id.startsWith('QC_HS_VER')) {
    return true
  }
  return false
}

function buildURL(relativeURL) {
  switch(process.env.NODE_ENV) {
    case 'preprod':
      return 'https://preprod.qualificationcheck.com/#' + relativeURL
    case 'sandbox':
      return 'https://sandbox.qualificationcheck.com/#' + relativeURL
    case 'production':
      return 'https://app.qualificationcheck.com/#' + relativeURL
    default:
      return 'http://app.qualificationcheck.local/#' + relativeURL
  }
}

function isString(str) {
  return typeof str === 'string' || str instanceof String
}

function educationName(verification, index) {
  return instituteName(verification, index, 'Education')
}

function employmentName(verification, index) {
  return instituteName(verification, index, 'Employment Verification')
  // Employer name should be returned as the institute name from the backend now
  // var name = null
  // if(verification.institute) {
  //   for(var i = 0; i < verification.institute.fields.length; i++) {
  //     if(verification.institute.fields[i].key === 'employerName' && verification.institute.fields[i].value) {
  //       name = verification.institute.fields[i].value
  //     }
  //   }
  // } else if(verification.fields && verification.fields.employerName) {
  //   name = verification.fields.employerName
  // }
  // if(name == null) {
  //   name = verification.institute.name
  // }
  // if(name == null) {
  //   name = 'Employment Verification ' + (index + 1)
  // } 
  // verification.name = name
  // return name
}

function proflicName(verification, index) {
  return instituteName(verification, index, 'Professional License')
}
function profcertName(verification, index) {
  return instituteName(verification, index, 'Professional Certificate')
}
function highschoolName(verification, index) {
  return instituteName(verification, index, 'High School')
}

function instituteName(verification, index, label) {
  var name = null
  if(verification.institute) {
    name = (verification.institute.names && verification.institute.names.length > 0 ? verification.institute.names[0].name : verification.institute.name)
  } else if(verification.instituteNames && verification.instituteNames.length > 0) {
    name = verification.instituteNames[0]
  } else if(verification.instituteName) {
    name = verification.instituteName
  } else {
    name = label + ' Verification ' + (index + 1)
  }
  verification.name = name
  return name
}

export default {
  getLatestTcsVersion,
  buildValidations,
  buildVerification,
  populateEmploymentVerification,
  buildInstitute,
  buildVerificationSubmission,
  buildApplicationDocuments,
  isEdu,
  isEmp,
  isId,
  isHSC,
  buildURL,
  educationName,
  employmentName,
  proflicName,
  profcertName,
  highschoolName,
  formatDate
}